import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

const CompanyProfile: React.FC = () => {
  const { id } = useParams();

  return (
    <Box>
      <Typography variant="h4">
        Company Profile - {id}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
        Company profile page coming soon...
      </Typography>
    </Box>
  );
};

export default CompanyProfile;